module.exports = __webpack_public_path__ + "media/images/home/arrow-6caca6f321c28408851ccea8dfedc87d.png";